//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
    mapActions,
    mapState
} from "vuex";
import AuthService from "../../services/AuthService";
import {
    date,
} from "quasar";
import numericsimple from "@/components/numericSimple";
import utils from "../../shared/utils";
import logger from "@/utils/logger";
import StockValueDialogWidget from "@/Widgets/StockValueDialogWidget.vue";
import lazyLoadSelect from "@/components/LazyLoadSelect";

export default {
    components: {
        numericsimple,
        StockValueDialogWidget,
        lazyLoadSelect
    },
    data() {
        return {
            disabledSaveStockItemButton: false,
            pagination: {
                rowsPerPage: 15, // current rows per page being displayed
                sortBy: "ProductNumber",
                descending: false,
            },
            columns: [{
                    name: "ProductNumber",
                    align: "left",
                    label: this.$t("stock.productNo"),
                    field: "productNumber",
                    style: "width: 300px",
                    sortable: true,
                },
                {
                    name: "ProductName",
                    align: "left",
                    label: this.$t("stock.productName"),
                    field: "productName",
                    sortable: true,
                },

                {
                    name: "Warehouse",
                    align: "left",
                    label: this.$t("stock.warehouse"),
                    field: "warehouseName",
                    style: "width:210px",
                    sortable: true,
                },
                {
                    name: "Location",
                    align: "left",
                    label: this.$t("stock.location"),
                    field: "locationName",
                    style: "width:210px",
                    sortable: true,
                },
                {
                    name: "lastCountDate",
                    align: "left",
                    label: "Sist telt",
                    field: "lastCountDate",
                    style: "width:210px",
                    format: (val) => date.formatDate(val, "DD-MM-YYYY"),
                    sortable: true,
                },
                {
                    name: "Quantity",
                    align: "right",
                    label: this.$t("stock.quantity"),
                    style: "width:90px",
                    field: "quantity",
                    sortable: true,
                },
            ],
            publicPath: process.env.BASE_URL,
            filter: "",
            stocks: [],
            showAction: false,
            selectedStock: {},
            showNewStock: false,
            showMove: false,
            showCreatelocation: false,
            showChange: false,
            adjustedQuantity: 0,
            quantity: 0,
            changeComment: "",
            newLocation: "",
            newWarehouseId: -1,
            newLocationId: -1,
            newProdctId: -1,
            Warehouses: [],
            FilterWarehouses: [],
            Locations: [],
            FilterLocations: [],
            showImportDialog: false,
            showStockValue: false,
            warehouseName: "",
            locationName: "",
            locationGroupName: "",
            warehouseId: -1,
            toggleUpdateJournal: true,
            showPostToggle: false,
        };
    },

    async mounted() {
        await this.refresh();
        this.Warehouses = this.warehouses;
        this.FilterWarehouses = this.warehouses;
        this.Locations = this.locations;
        this.FilterLocations = this.locations;
    },
    
    computed: {
        ...mapState("main", ["warehouses", "locations"]),

        newQuantityForLocation: function () {
            return this.selectedStock.quantity + this.adjustedQuantity;
        },
    },

    // watch: {
    //   newWarehouseId(newValue, oldValue) {
    //     if (newValue != oldValue) {
    //       this.newLocationId = -1;
    //     }
    //   },
    // },

    methods: {
        ...mapActions("main", [
            "getStocksIncludeEmpty",
            "getStocks",
            "postStock",
            "moveStock",
            "getLocation",
            "postLocation",
            "exportStocks",
            "deleteStock",
            "getReferencesProducts",
            "getProduct"
        ]),

        async fetchProducts({ pageNumber, pageSize, searchQuery }) {
            try {
                const result = await this.getReferencesProducts({
                    pageNumber,
                    pageSize,
                    searchQuery,
                    sortBy: 'ProductNumber',
                    sortDescending: false
                })
                return result
            } catch (error) {
                logger.log('Error fetching products:', error)
                return { items: [], totalPages: 1 }
            }
        },

        async fetchProduct(productId) {
            try {
                const result = await this.getProduct(productId)
                return result
            } catch (error) {
                logger.log('Error fetching product:', error)
                return null;
            }
        },

        productLabel(product) {
            if (!product) return ''
            return `${product.productNumber}: ${product.productName}`
        },

        onRejected(rejectedEntries) {
            this.$q.notify({
                type: 'negative',
                message: `${rejectedEntries.length} file(s) did not pass validation constraints`
            })
        },

        warehouseChanged() {
            this.newLocationId = -1;
            var remoteWarehouse = !this.warehouses.find((x) => x.id == this.newWarehouseId).isRemoteWarehouse;
            this.showPostToggle = remoteWarehouse;
        },

        onRowClick(evt, row) {
            this.resetForm();
            this.selectedStock = row;
            this.newWarehouseId = row.warehouseId;
            this.showAction = true;
        },

        resetForm() {
            this.showMove = false;
            this.showChange = false;
            this.showNewStock = false;
            this.showPostToggle = false;
            this.adjustedQuantity = 0;
            this.quantity = 0;
            this.changeComment = "";
            this.newLocationId = -1;
            this.newProdctId = -1;
            this.selectedStock = {};
        },

        newStock() {
            this.resetForm();
            this.showNewStock = true;
            this.showAction = true;
            this.showPostToggle = true;
        },

        async showStockValueClick() {
            this.showStockValue = true;
        },

        enterCheck(event) { 
            if (event.key === 'Enter' && this.filter != "") {
                var stocks = this.$refs.stockTable.computedRows;
                if(stocks.length == 1) {
                    this.onRowClick(event, stocks[0]);
                }
            }

        },

        async exportStocksClick() {
            const notif = this.$q.notify({
                message: this.$t("common.downloading"),
                timeout: 0,
                spinner: true,
            });
            var res = await this.exportStocks();
            notif();

            const url = window.URL.createObjectURL(new Blob([res], { 
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" 
            }));
            const link = document.createElement("a");
            link.href = url;
            
            link.setAttribute("download", "AvareStocksExport.xlsx");

            document.body.appendChild(link);
            link.click();
        },

        async refresh() {
            this.stocks = [];
            const notif = this.$q.notify({
                type: "ongoing",
                message: "Laster data...",
            });

            this.stocks = await this.getStocks();

            setTimeout(() => {
                notif();
            }, 500);
        },

        async deleteStockItem() {
            try {
                if (await this.deleteStock(this.selectedStock.id)) {
                    this.$q.notify({
                        type: "positive",
                        message: this.$t("stock.deleteCompleted"),
                    });
                } else {
                    this.$q.notify({
                        type: "negative",
                        message: this.$t("common.errorSave"),
                    });
                }
                await this.refresh();
                this.showAction = false;
            } catch (err) {
                this.showAction = false;

                logger.log(err.message);
                this.$q.notify({
                    type: "negative",
                    message: `${this.$t(
            "common.errorSave"
          )}. ${this.$utils.GetErrorMessage(err)}`,
                });
            }
        },

        async saveStockItem() {
            this.disabledSaveStockItemButton = true;
            if (this.showChange) {
                var postStock = {};
                postStock.productId = this.selectedStock.productId;
                postStock.locationId = this.selectedStock.locationId;
                postStock.quantityChange = this.adjustedQuantity;
                postStock.comment = this.changeComment;
                
                var remoteWarehouse = !this.warehouses.find((x) => x.id == this.selectedStock.warehouseId).isRemoteWarehouse;   
                logger.log(remoteWarehouse);
                postStock.UpdateJournal = remoteWarehouse;

                try {
                    var createdDto = await this.postStock(postStock);
                    if (createdDto && createdDto.id > 0) {
                        await this.refresh();
                        this.showAction = false;
                        this.disabledSaveStockItemButton = false;

                        this.$q.notify({
                            type: "positive",
                            message: this.$t("stock.changeCompleted"),
                        });
                    } else {
                        this.$q.notify({
                            type: "negative",
                            message: this.$t("common.errorSave"),
                        });
                    }
                } catch (err) {
                    this.showAction = false;
                    this.disabledSaveStockItemButton = false;

                    logger.log(err.message);
                    this.$q.notify({
                        type: "negative",
                        message: `${this.$t(
              "common.errorSave"
            )}. ${this.$utils.GetErrorMessage(err)}`,
                    });
                }
            } else if (this.showMove) {
                var moveStock = {};
                moveStock.productId = this.selectedStock.productId;
                moveStock.fromLocationId = this.selectedStock.locationId;
                moveStock.toLocationId = this.newLocationId;
                moveStock.quantity = parseFloat(this.quantity);
                moveStock.comment = this.changeComment;

                try {
                    var success = await this.moveStock(moveStock);

                    if (success) {
                        await this.refresh();
                        this.showAction = false;
                        this.$q.notify({
                            type: "positive",
                            message: this.$t("stock.moveCompleted"),
                        });
                    } else {
                        this.showAction = false;
                        this.$q.notify({
                            type: "negative",
                            message: this.$t("common.errorSave"),
                        });
                    }
                } catch (err) {
                    this.showAction = false;

                    logger.log(err.message);
                    this.$q.notify({
                        type: "negative",
                        message: `${this.$t(
              "common.errorSave"
            )}. ${this.$utils.GetErrorMessage(err)}`,
                    });
                }
            } else if (this.showNewStock) {
                var newStock = {};
                newStock.productId = this.newProdctId;
                newStock.locationId = this.newLocationId;
                newStock.quantityChange = parseFloat(this.quantity);
                newStock.comment = "";
                newStock.UpdateJournal = this.toggleUpdateJournal;

                try {
                    var newStockDto = await this.postStock(newStock);
                    if (newStockDto && newStockDto.id > 0) {
                        await this.refresh();
                        this.showAction = false;

                        this.$q.notify({
                            type: "positive",
                            message: this.$t("stock.createComplete"),
                        });
                    } else {
                        this.$q.notify({
                            type: "negative",
                            message: this.$t("common.errorSave"),
                        });
                    }
                } catch (err) {
                    this.showAction = false;

                    logger.log(err.message);
                    this.$q.notify({
                        type: "negative",
                        message: `${this.$t(
              "common.errorSave"
            )}. ${this.$utils.GetErrorMessage(err)}`,
                    });
                }
            }
            this.disabledSaveStockItemButton = false;
        },

        async createLocation() {
            var object = {};
            try {
                object["locationName"] = this.locationName;
                object["locationGroupName"] = this.locationGroupName;
                object["isDeleted"] = false;
                object["warehouseId"] = this.warehouseId;

                var res = await this.postLocation(object);
                this.$q.notify({
                    type: "positive",
                    message: this.$t("common.saveOk"),
                });
                await this.getLocation();
                this.Locations = this.locations;
                this.FilterLocations = this.locations;
                this.newWarehouseId = res.warehouseId;
                this.newLocationId = res.id;
            } catch (error) {
                logger.log("error", error);
                this.$q.notify({
                    type: "negative",
                    message: this.$t("common.errorSave"),
                });
            }
        },

        async factoryFn() {
            //var auth = await AuthService.create();
            //var token = await auth.getAccessToken();

            var token = null;
            try {
                token = window.App.$store.getters["main/getUser"]().access_token;

                if (!token) {
                    throw new Error();
                }
            } catch {
                var auth = await AuthService.create();
                token = await auth.getAccessToken();
            }

            var baseUrl = (await utils.GetConfig()).API_BASE_URL;
            var url = baseUrl + "/api/Stock/Import";

            return new Promise((resolve) => {
                resolve({
                    url: url,
                    method: "POST",
                    headers: [{
                        name: "Authorization",
                        value: `Bearer ${token}`
                    }],
                });
            });
        },

        getWarehouseFilter(val, update) {
            if (!this.Warehouses) {
                update();
                return;
            }
            update(() => {
                this.Warehouses = this.FilterWarehouses.filter(
                    (w) =>
                    !w.isDeleted &&
                    w.warehouseName.toLowerCase().indexOf(val.toLowerCase()) > -1
                );
            });
        },

        getLocationsFilter(val, update) {
            if (!this.Locations) {
                update();
                return;
            }
            update(() => {
                this.Locations = this.FilterLocations.filter(
                    (l) =>
                    (this.newWarehouseId < 1 || l.warehouseId == this.newWarehouseId) &&
                    !l.isDeleted &&
                    l.locationName.toLowerCase().indexOf(val.toLowerCase()) > -1
                );
            });
        },
    },
};
